module.exports = __webpack_public_path__ + "static/illustration-do-2a8d3877a5e520e92bb4f0ea06ce87f3.png";